/**
 * 通过数据源ID获取整个数据源的设置信息
 * @param {数据源ID} dataSourceId 
 * @param {成功回调方法} success 
 * @param {失败回调方法} error 
 * @param {最后执行回调方法} finallyCb 
 */
function getConfig(dataSourceId, success, error, finallyCb = () => {}) {
    if (!IDM.setting.api.dataSourceFetchListApi && !IDM.setting.mockurl.dataSourceFetchListApi) {
        IDM.message.warning("请求数据源接口未配置！请在setting.js文件[IDM.setting.api.dataSourceFetchListApi]下面配置接口地址。")
        return;
    }
    IDM.http
        .get(IDM.setting.api.dataSourceFetchListApi || IDM.setting.mockurl.dataSourceFetchListApi, {
            dataSourceId: dataSourceId
        })
        .then(success)
        .catch(error)
        .finally(finallyCb);
}
/**
 * 请求数据源（异步）
 * @param {数据源ID} dataSourceId 
 * @param {参数：moduleObject:{组件对象},param:{}} paramInfo 
 * @param {成功回调方法} successCallback 
 * @param {失败回调方法} errorCallback
 * @param {最后回调方法} finallyCallback
 */
function request(dataSourceId, paramInfo, successCallback, errorCallback, finallyCallback = () => {}) {
    return new Promise((resolve, reject) => {
        if (!dataSourceId) {
            IDM.message.error("数据源ID不可少！")
            if(errorCallback) {
                errorCallback({
                    type: 'error',
                    message: '数据源ID不可少！'
                })
            }
            reject('数据源ID不可少')
            finallyCallback()
            return;
        }
        this.getConfig(dataSourceId, function (dsRes) {
            var dataSourceRes = dsRes && dsRes.data;
            if (dataSourceRes.code == "200") {
                //请求成功
                var dataSourceData = dataSourceRes.data;
                var resultData;
                switch (dataSourceData.type) {
                    case 1:
                        //1：接口API
                        //首先判断是前端请求还是后端请求，如果是后端请求需要传递参数给后端再次请求
                        var httpApi = dataSourceData.loadType == 1 ? IDM.setting.api.dataSourceForwardApi : dataSourceData.api;
                        
                        if(!httpApi){
                            IDM.message.warning(dataSourceData.loadType == 1?"请求数据源后端转发接口未配置！请在setting.js文件[IDM.setting.api.dataSourceForwardApi]下面配置接口地址。":"请求地址不能为空！")
                            return false;
                        }
                        var httpParam = {}, httpHeader = {};
                        if (dataSourceData.paramJson) {
                            try {
                                //[{\"name\":\"1\",\"valueType\":1,\"value\":true},{\"name\":\"1\",\"valueType\":0,\"value\":\"3\"}]
                                var paramJSON = JSON.parse(dataSourceData.paramJson);
                                for (let index = 0; index < paramJSON.length; index++) {
                                    var paramObject = paramJSON[index];
                                    var paramValue = "";
                                    switch (paramObject.valueType) {
                                        case 0://字符串
                                        case 1://布尔值
                                            paramValue = paramObject.value;
                                            break;
                                        case 2://表达式
                                            var replaveValue = {};
                                            if (paramInfo) {
                                                replaveValue = { ...paramInfo };
                                                if (paramInfo.param && IDM.type(paramInfo.param) == "object") {
                                                    IDM.mix(replaveValue, paramInfo.param);
                                                }
                                            }
                                            replaveValue["IDM"] = IDM;
                                            paramValue = IDM.express.replace(paramObject.value, replaveValue, true)
                                            break;
                                    }
                                    httpParam[paramObject.name] = paramValue;
                                }
                            } catch (error) {
    
                            }
                        }
                        if (dataSourceData.headerJson) {
                            try {
                                //[{\"name\":\"1\",\"valueType\":1,\"value\":true},{\"name\":\"1\",\"valueType\":0,\"value\":\"3\"}]
                                var paramJSON = JSON.parse(dataSourceData.headerJson);
                                for (let index = 0; index < paramJSON.length; index++) {
                                    var paramObject = paramJSON[index];
                                    var paramValue = "";
                                    switch (paramObject.valueType) {
                                        case 0://字符串
                                        case 1://布尔值
                                            paramValue = paramObject.value;
                                            break;
                                        case 2://表达式
                                            var replaveValue = {};
                                            if (paramInfo) {
                                                replaveValue = { ...paramInfo };
                                                if (paramInfo.param && IDM.type(paramInfo.param) == "object") {
                                                    IDM.mix(replaveValue, paramInfo.param);
                                                }
                                            }
                                            replaveValue["IDM"] = IDM;
                                            paramValue = IDM.express.replace(paramObject.value, replaveValue, true)
                                            break;
                                    }
                                    httpHeader[paramObject.name] = paramValue;
                                }
                            } catch (error) {
    
                            }
                        }
                        //参数处理
                        if(dataSourceData.functionParam){
                            try {
                                var fun = IDM.express.eval(dataSourceData.functionParam);
                                httpParam = fun(httpParam);
                            } catch (error) {
        
                            }
                        }
                        var optionObject = {};
                        if(dataSourceData.loadType == 1){
                            //后端转发
                            httpParam={
                                paramJSON:httpParam,
                                headerJSON:httpHeader,
                                dataSourceData
                            }
                            optionObject["headers"]={
                                "Content-Type": "application/json;charset=UTF-8"
                            };
                        }else{
                            optionObject["headers"] = httpHeader;
                            optionObject["timeout"] = dataSourceData.timeout || 0;
                            optionObject["crossDomain"] = dataSourceData.crossOrigin === 0 ? false : true;
                        }
    
    
                        IDM.http[dataSourceData.requestType == "GET"&&dataSourceData.loadType != 1 ? "get" : "post"](httpApi, httpParam, optionObject).then(function (dataRes) {
                            resultData = dataRes;
                            if (dataSourceData.functionResult) {
                                //需要进行函数执行
                                try {
                                    var fun = IDM.express.eval(dataSourceData.functionResult);
                                    resultData = fun(resultData);
                                } catch (error) {
                                    console.error(error);
                                }
                            }
                            if (successCallback) {
                                successCallback(resultData)
                            }
                            resolve(resultData)
                        }).catch(function (dataError) {
                            if (errorCallback) {
                                errorCallback(dataError)
                            }
                            if (dataSourceData.functionError) {
                                try {
                                    var fun = IDM.express.eval(dataSourceData.functionError);
                                    fun(dataError);
                                } catch (error) {
                                    console.error(error);
                                }
                            } else {
                                IDM.message.error("数据源【" + dataSourceData.title + "】配置的接口请求失败！" + dataError.message)
                            }
                            reject(dataError)
                        }).finally(finallyCallback)
    
                        break;
                    case 2:
                    //2：静态数据
                    case 3:
                    //3：json文件
                    case 5:
                        //5：csv文件
                        //直接返回，只不过2是返回resultJson，3、5返回fileContent，同时两个都要判断是否要经过格式化
                        resultData = dataSourceData.type == 2 ? dataSourceData.resultJson : dataSourceData.fileContent;
                        if(dataSourceData.type != 5){
                            try {
                                resultData = JSON.parse(resultData);
                            } catch (error) {
                                
                            }
                        }
                        if (dataSourceData.functionResult) {
                            //需要进行函数执行
                            try {
                                var fun = IDM.express.eval(dataSourceData.functionResult);
                                resultData = fun(resultData);
                            } catch (error) {
                                console.error(error);
                            }
                        }
                        if (successCallback) {
                            successCallback(resultData)
                        }
                        resolve(resultData)
                        finallyCallback()
                        break;
                    case 4:
                        //4：sql语句
                        if(!IDM.setting.api.dataSourceDbSqlApi){
                            IDM.message.warning("请求数据源执行sql接口未配置！请在setting.js文件[IDM.setting.api.dataSourceDbSqlApi]下面配置接口地址。")
                            return;
                        }
                        var sqlParam = {};
                        if (dataSourceData.paramJson) {
                            try {
                                //[{\"name\":\"1\",\"valueType\":1,\"value\":true},{\"name\":\"1\",\"valueType\":0,\"value\":\"3\"}]
                                var paramJSON = JSON.parse(dataSourceData.paramJson);
                                for (let index = 0; index < paramJSON.length; index++) {
                                    var paramObject = paramJSON[index];
                                    var paramValue = "";
                                    switch (paramObject.valueType) {
                                        case 0://字符串
                                        case 1://布尔值
                                            paramValue = paramObject.value;
                                            break;
                                        case 2://表达式
                                            var replaveValue = {};
                                            if (paramInfo) {
                                                replaveValue = { ...paramInfo };
                                                if (paramInfo.param && IDM.type(paramInfo.param) == "object") {
                                                    IDM.mix(replaveValue, paramInfo.param);
                                                }
                                            }
                                            replaveValue["IDM"] = IDM;
                                            paramValue = IDM.express.replace(paramObject.value, replaveValue, true)
                                            break;
                                    }
                                    sqlParam[paramObject.name] = paramValue;
                                }
                            } catch (error) {
    
                            }
                        }
                        //参数处理
                        if(dataSourceData.functionParam){
                            try {
                                var fun = IDM.express.eval(dataSourceData.functionParam);
                                sqlParam = fun(sqlParam);
                            } catch (error) {
        
                            }
                        }
                        paramInfo.moduleObject?delete paramInfo.moduleObject:null;
                        //只传数据源ID
                        IDM.http.post(IDM.setting.api.dataSourceDbSqlApi, {
                            dataSourceId,
                            paramInfo:paramInfo,
                            sqlParam
                        }, {
                            headers:{
                                "Content-Type": "application/json;charset=UTF-8"
                            }
                        }).then(function (dataRes) {
                            try {
                                resultData = dataRes;
                                if (dataSourceData.functionResult) {
                                    //需要进行函数执行
                                    try {
                                        var fun = IDM.express.eval(dataSourceData.functionResult);
                                        resultData = fun(resultData);
                                    } catch (error) {
                                        console.error(error);
                                    }
                                }
                                if (successCallback) {
                                    successCallback(resultData)
                                }
                                resolve(resultData)
                            } catch (error) {
                                console.error("组件内部异常",error);
                                reject(error)
                            }
                        }).catch(function (dataError) {
                            if (errorCallback) {
                                errorCallback(dataError)
                            }
                            if (dataSourceData.functionError) {
                                try {
                                    var fun = IDM.express.eval(dataSourceData.functionError);
                                    fun(dataError);
                                } catch (error) {
                                    console.error(error);
                                }
                            } else {
                                IDM.message.error("数据源【" + dataSourceData.title + "】配置的接口请求失败！" + dataError.message)
                            }
                            reject(dataError)
                        }).finally(finallyCallback)
                        break;
                    case 6:
                        var httpApi = IDM.setting.api.dataModelGetDataApi;
                        
                        if(!httpApi){
                            IDM.message.warning("请求数据模型接口未配置！请在setting.js文件[IDM.setting.api.dataModelGetDataApi]下面配置接口地址。")
                            reject()
                            return false;
                        }
                        debugger
                        IDM.http.get(httpApi, {
                            id:dataSourceData.datamodelId
                        }).then(function (dataRes) {
                            resultData = dataRes;
                            if (dataSourceData.functionResult) {
                                //需要进行函数执行
                                try {
                                    var fun = IDM.express.eval(dataSourceData.functionResult);
                                    resultData = fun(resultData);
                                } catch (error) {
                                    console.error(error);
                                }
                            }
                            if (successCallback) {
                                successCallback(resultData)
                            }
                            resolve(resultData)
                        }).catch(function (dataError) {
                            if (errorCallback) {
                                errorCallback(dataError)
                            }
                            if (dataSourceData.functionError) {
                                try {
                                    var fun = IDM.express.eval(dataSourceData.functionError);
                                    fun(dataError);
                                } catch (error) {
                                    console.error(error);
                                }
                            } else {
                                IDM.message.error("数据源【" + dataSourceData.title + "】配置的数据模型请求失败！" + dataError.message)
                            }
                            reject(dataError)
                        }).finally(finallyCallback)
                    break;
                }
            } else {
                IDM.message.error(dataSourceRes.message)
            }
        }, function (error) {
            if (errorCallback) {
                errorCallback(error)
            } else {
                IDM.message.error("数据源配置信息获取失败！" + error.message)
            }
            reject(error)
        })
    })
}
/**
 * 数据源调试（异步）
 * @param {表单对象，参数数组，请求头数组} dataSourceObject 
 * @param {成功回调方法} successCallback 
 * @param {失败回调方法} errorCallback 
 */
function debug(dataSourceObject,successCallback, errorCallback){
    var resultData;
    switch (dataSourceObject.type) {
        case "1":
            //1：接口API
            var httpApi = dataSourceObject.loadType == 1 ? IDM.setting.api.dataSourceForwardApi : dataSourceObject.api;
            
            if(!httpApi){
                IDM.message.warning(dataSourceObject.loadType == 1?"请求数据源后端转发接口未配置！请在setting.js文件[IDM.setting.api.dataSourceForwardApi]下面配置接口地址。":"请求地址不能为空！")
                return false;
            }
            var httpParam = {}, httpHeader = {};
            if (dataSourceObject.paramJson_debug) {
                try {
                    //[{\"name\":\"1\",\"valueType\":1,\"value\":true},{\"name\":\"1\",\"valueType\":0,\"value\":\"3\"}]
                    var paramJSON = dataSourceObject.paramJson_debug;
                    for (let index = 0; index < paramJSON.length; index++) {
                        var paramObject = paramJSON[index];
                        var paramValue = "";
                        switch (paramObject.valueType) {
                            case 0://字符串
                            case 1://布尔值
                            case 2://表达式
                                paramValue = paramObject.value;
                                break;
                        }
                        httpParam[paramObject.name] = paramValue;
                    }
                } catch (error) {

                }
            }
            if (dataSourceObject.headerJson_debug) {
                try {
                    //[{\"name\":\"1\",\"valueType\":1,\"value\":true},{\"name\":\"1\",\"valueType\":0,\"value\":\"3\"}]
                    var paramJSON = dataSourceObject.headerJson_debug;
                    for (let index = 0; index < paramJSON.length; index++) {
                        var paramObject = paramJSON[index];
                        var paramValue = "";
                        switch (paramObject.valueType) {
                            case 0://字符串
                            case 1://布尔值
                            case 2://表达式
                                paramValue = paramObject.value;
                                break;
                        }
                        httpHeader[paramObject.name] = paramValue;
                    }
                } catch (error) {

                }
            }
            //参数处理
            if(dataSourceObject.functionParam){
                try {
                    var fun = IDM.express.eval(dataSourceObject.functionParam);
                    httpParam = fun(httpParam);
                } catch (error) {

                }
            }
            var optionObject = {};
            if(dataSourceObject.loadType == 1){
                //后端转发
                httpParam={
                    paramJSON:httpParam,
                    headerJSON:httpHeader,
                    dataSourceData:dataSourceObject
                }
                optionObject["headers"]={
                    "Content-Type": "application/json;charset=UTF-8"
                };
            }else{
                optionObject["headers"] = httpHeader;
                optionObject["timeout"] = dataSourceObject.timeout || 0;
                optionObject["crossDomain"] = dataSourceObject.crossOrigin === 0 ? false : true;
            }

            IDM.http[dataSourceObject.requestType == "GET"&&dataSourceObject.loadType != 1 ? "get" : "post"](httpApi, httpParam, optionObject).then(function (dataRes) {
                resultData = dataRes;
                if (dataSourceObject.functionResult) {
                    //需要进行函数执行
                    try {
                        var fun = IDM.express.eval(dataSourceObject.functionResult);
                        resultData = fun(resultData);
                    } catch (error) {
                        console.error(error);
                    }
                }
                if (successCallback) {
                    successCallback(resultData)
                }
            }).catch(function (dataError) {
                if (errorCallback) {
                    errorCallback(dataError)
                }
                if (dataSourceObject.functionError) {
                    try {
                        var fun = IDM.express.eval(dataSourceObject.functionError);
                        fun(dataError);
                    } catch (error) {
                        console.error(error);
                    }
                }
            })
            break;
        case "4":
            //4：sql语句
            if(!IDM.setting.api.dataSourceDbSqlApi){
                IDM.message.warning("请求数据源执行sql接口未配置！请在setting.js文件[IDM.setting.api.dataSourceDbSqlApi]下面配置接口地址。")
                return false;
            }
            if(!dataSourceObject.dataSourceId){
                IDM.message.warning("安全限制，请保存后再进行调试")
                return false;
            }
            var sqlParam = {};
            if (dataSourceObject.paramJson_debug) {
                try {
                    //[{\"name\":\"1\",\"valueType\":1,\"value\":true},{\"name\":\"1\",\"valueType\":0,\"value\":\"3\"}]
                    var paramJSON = dataSourceObject.paramJson_debug;
                    for (let index = 0; index < paramJSON.length; index++) {
                        var paramObject = paramJSON[index];
                        var paramValue = "";
                        switch (paramObject.valueType) {
                            case 0://字符串
                            case 1://布尔值
                            case 2://表达式
                                paramValue = paramObject.value;
                                break;
                        }
                        sqlParam[paramObject.name] = paramValue;
                    }
                } catch (error) {

                }
            }
            //参数处理
            if(dataSourceObject.functionParam){
                try {
                    var fun = IDM.express.eval(dataSourceObject.functionParam);
                    sqlParam = fun(sqlParam);
                } catch (error) {

                }
            }
            //只传数据源ID
            IDM.http.post(IDM.setting.api.dataSourceDbSqlApi, {
                dataSourceId:dataSourceObject.dataSourceId,
                sqlParam
            }, {
                headers:{
                    "Content-Type": "application/json;charset=UTF-8"
                }
            }).then(function (dataRes) {
                resultData = dataRes;
                if (dataSourceObject.functionResult) {
                    //需要进行函数执行
                    try {
                        var fun = IDM.express.eval(dataSourceObject.functionResult);
                        resultData = fun(resultData);
                    } catch (error) {
                        console.error(error);
                    }
                }
                if (successCallback) {
                    successCallback(resultData)
                }
            }).catch(function (dataError) {
                if (errorCallback) {
                    errorCallback(dataError)
                }
                if (dataSourceObject.functionError) {
                    try {
                        var fun = IDM.express.eval(dataSourceObject.functionError);
                        fun(dataError);
                    } catch (error) {
                        console.error(error);
                    }
                }
            })
            break;
        case "2":
            //2：静态数据
        case "3":
            //3：json文件
        case "5":
            //5：csv文件
            //直接返回，只不过2是返回resultJson，3、5返回fileContent，同时两个都要判断是否要经过格式化
            resultData = dataSourceObject.type == 2 ? dataSourceObject.resultJson : dataSourceObject.fileContent;
            if(dataSourceObject.type != 2){
                //处理文件内容
                if(dataSourceObject.file_name&&dataSourceObject.file_name.length){
                    resultData = dataSourceObject.file_name[dataSourceObject.file_name.length-1].content;
                }
            }
            if(dataSourceObject.type != 5){
                try {
                    resultData = JSON.parse(resultData);
                } catch (error) {
                    if (errorCallback) {
                        errorCallback(error)
                    }
                }
            }
            if (dataSourceObject.functionResult) {
                //需要进行函数执行
                try {
                    var fun = IDM.express.eval(dataSourceObject.functionResult);
                    resultData = fun(resultData);
                } catch (error) {
                    console.error(error);
                }
            }
            if (successCallback) {
                successCallback(resultData)
            }
            break;
        case "6":
            var httpApi = IDM.setting.api.dataModelGetDataApi;
            
            if(!httpApi){
                IDM.message.warning("请求数据模型接口未配置！请在setting.js文件[IDM.setting.api.dataModelGetDataApi]下面配置接口地址。")
                return false;
            }
            IDM.http.get(httpApi, {
                id:dataSourceObject.datamodelId
            }).then(function (dataRes) {
                resultData = dataRes;
                if (dataSourceObject.functionResult) {
                    //需要进行函数执行
                    try {
                        var fun = IDM.express.eval(dataSourceObject.functionResult);
                        resultData = fun(resultData);
                    } catch (error) {
                        console.error(error);
                    }
                }
                if (successCallback) {
                    successCallback(resultData)
                }
            }).catch(function (dataError) {
                if (errorCallback) {
                    errorCallback(dataError)
                }
                if (dataSourceObject.functionError) {
                    try {
                        var fun = IDM.express.eval(dataSourceObject.functionError);
                        fun(dataError);
                    } catch (error) {
                        console.error(error);
                    }
                }
            })
        break;
    }
}
export default {
    request,
    getConfig,
    debug
}